<template>
  <v-alert v-if="!$root.isFullFinancialDataAllowedToView" type="error">{{ $t('Errors.AccessDeniedAuthorizationFailed') }}</v-alert>
  <div v-else>
    <v-overlay :value="loading" :absolute="true">
      <v-progress-circular indeterminate></v-progress-circular>
    </v-overlay>

    <ExpensesReportTemplate v-if="$route.name === 'reportPrint'"
                            :entries="$route.params.report_number > 0 ? null : items"
                            :reportData="reportData"
                            :totals="totalsCounts"
                            :from="from"
                            :to="to"
                            :currentDateTime="currentDateTime"
                            :key="'reportTemplateKey' + items.length"
                            :companyId="companyId"
    />
    <v-card v-else>
      <v-card-title :style="{ backgroundColor: $root.currentTheme.background }">
        {{$t('Reports.Expenses')}}
        <v-btn @click="$emit('on-import-from-pilot',)"
               :loading="importPilotLoading"
               small
               class="ml-2 mb-1"><v-icon left>mdi-file-import</v-icon>Import Expenses From Pilot</v-btn>
        <v-btn @click="$emit('on-import-from-fleet-one',)"
               :loading="importFleetOneLoading"
               small
               class="ml-2 mb-1"><v-icon left>mdi-file-import</v-icon>Import Expenses From Fleet One</v-btn>
        <v-btn @click="$emit('on-import-from-tcs',)"
               :loading="importTCSLoading"
               small
               class="ml-2 mb-1"><v-icon left>mdi-file-import</v-icon>Import Expenses From TCS</v-btn>
      </v-card-title>
      <ExpensesTotals :from="from"
                   :to="to"
                   :key="from+to+reportsGroupsListKey"
                   :totalsCountsData="totalsCounts"/>
      <v-divider/>
      <ReportActions :userId="$store.getters.currentUser.id"
                     :from="from"
                     :to="to"
                     :paramsType="$route.params.type"
                     :selectedItems="selectedItems"
                     :hideActionsBtn="true"
                     @create-report-group="createReport"
                     @mark-selected-as-payed-and-create-report-group="markSelectedAsPayedAndCreateReportGroup"
                     @show-saved-reports="$root.onShowReportsModal"
      />
      <v-layout v-if="$root.isFullFinancialDataAllowedToView">
        <v-flex shrink class="pa-1">
          <FiltersPanel
            :loading="loading"
            :isExpansionPanel="$root.isMobile"
            ref="filtersPanel"
            prefix="expensesReportFilter"
            :items="[userFilter, truckFilter, productFilter, typeFilter, methodFilter]"
            :key="userFilter.name + userFilter.list.length + truckFilter.name + truckFilter.list.length + productFilter.name + productFilter.list.length + typeFilter.name + typeFilter.list.length"
            outlined
            @change="onFilterChanged"
          />
        </v-flex>
        <v-flex grow class="pa-1">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            label="Search"
            single-line
            outlined dense
            hide-details
          />
        </v-flex>
        <v-flex shrink v-if="$root.isMobile">
          <v-btn class="mt-1 ml-1"
                  @click="$refs.filtersPanel.showFiltersDrawer()">
                  <v-icon>mdi-filter</v-icon>
          </v-btn>
        </v-flex>
        <!--<v-flex shrink>
          <v-btn class="ma-1" :disabled="selectedItems.length === 0" @click="createReportGroup(0, lastReportsGroupNumber + 1, $route.params.type, from, to)"><v-icon left>mdi-clipboard-check-outline</v-icon> {{$t('Reports.CreateReportsGroup')}}</v-btn>
        </v-flex>-->
      </v-layout>

      <v-list v-if="$root.isMobile">
        <v-list-item-group
          v-model="selectedItems"
          multiple
          active-class=""
        >
          <template v-for="item in items">
            <v-list-item :key="item.id" :value="item">
              <template v-slot:default="{ active }">
                  <v-list-item-icon>
                    <v-checkbox :input-value="active"/>
                  </v-list-item-icon>
                  <v-list-item-content @click.stop="onShowExpenses(item.expensesJSON, item.finished, item.loadId)">
                    <small>{{ item.TrxDate }}</small>
                    <span class="text-nowrap">
                      <v-icon>mdi-account</v-icon>&nbsp;<a href="#" @click.stop="$root.onShowUserPreview(item.createdBy, item.userCreatedFirstName + ' ' + item.userCreatedLastName)">{{item.userCreatedFirstName}} {{item.userCreatedLastName}}</a>
                    </span>
                    <span class="text-nowrap">
                    <v-icon>mdi-truck</v-icon>&nbsp;<a href="#" @click.stop="$root.onShowTruckPreview(item.truckId, item.truckName)">{{item.truckName}}</a>
                    </span>
                    <span class="text-nowrap">
                      <v-icon style="width: 1.5rem; height: 1.5rem;">$vuetify.icons.drivingWheelIcon</v-icon>&nbsp;<a href="#" @click.stop="$root.onShowUserPreview(item.userId, item.userFirstName + ' ' + item.userLastName)">{{item.userFirstName}} {{item.userLastName}}</a>
                    </span>
                  </v-list-item-content>
                  <v-list-item-action>
                    <a href="#" @click.stop="$root.onShowLoadPreview(item.loadId, item.truckId)">#{{item.loadId}}</a>
                    <v-icon v-if="item.Transaction" right>mdi-import</v-icon>
                    <span v-if="item.compensateCode === 0">{{$t('ExpensesShort')}}</span>
                    <span v-else-if="item.compensateCode === 1">{{$t('CompensateShort')}}</span>
                    <span v-else-if="item.compensateCode === 2">{{$t('AddToSalaryShort')}}</span>
                    <span v-else-if="item.compensateCode === 3">{{$t('Fine')}}</span>
                    {{item.Quantity}} x {{$root.moneyValue(item.InvoiceAmount/item.Quantity, 2)}}
                    <b>{{$root.moneyValue(item.InvoiceAmount, 2)}}</b>
                  </v-list-item-action>
              </template>
            </v-list-item>
            <v-expansion-panels flat dense>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  {{ $t('Details') }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <span v-if="item.paymentMethod">
                    Method: <b>{{item.paymentMethod}}</b>
                  </span>
                  <span v-if="item.Transaction"><br/>
                    Transaction #: <b>{{item.Transaction}}</b>
                  </span>
                  <span v-if="item.Product"><br/>
                    Product: <b>{{item.Product}}</b>
                  </span>
                </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <v-divider/>
          </template>
        </v-list-item-group>
      </v-list>

      <v-data-table
        v-else
        dense
        :headers="headers"
        :items="items"
        :search="search"
        :items-per-page="-1"
        hide-default-footer
        fixed-header
        v-model="selectedItems"
        show-select
        @item-selected="onItemSelected"
        @toggle-select-all="onItemSelected"
        @click:row="onShowExpenses($event.expensesJSON, $event.finished, $event.loadId)"
      >
        <template v-slot:item.createdBy="{ item }">
          <a href="#" @click.stop="$root.onShowUserPreview(item.createdBy, item.userCreatedFirstName + ' ' + item.userCreatedLastName)">{{item.userCreatedFirstName}} {{item.userCreatedLastName}}</a>
        </template>
        <template v-slot:item.loadId="{ item }">
          <a href="#" @click.stop="$root.onShowLoadPreview(item.loadId, item.truckId)">#{{item.loadId}}</a>
          <v-icon v-if="item.Transaction" right>mdi-import</v-icon>
        </template>
        <template v-slot:item.compensate="{ item }">
          <span v-if="item.compensateCode === 0">{{$t('Expenses')}}</span>
          <span v-else-if="item.compensateCode === 1">{{$t('Compensate')}}</span>
          <span v-else-if="item.compensateCode === 2">{{$t('AddToSalary')}}</span>
          <span v-else-if="item.compensateCode === 3">{{$t('Fine')}}</span>
        </template>
        <template v-slot:item.truckName="{ item}">
          <a href="#" @click.stop="$root.onShowTruckPreview(item.truckId, item.truckName)">{{item.truckName}}</a>
        </template>
        <template v-slot:item.user="{ item }">
          <a href="#" @click.stop="$root.onShowUserPreview(item.userId, item.userFirstName + ' ' + item.userLastName)">{{item.userFirstName}} {{item.userLastName}}</a>
        </template>
        <template v-slot:item.PerItem="{ item }">
          {{$root.moneyValue(item.InvoiceAmount/item.Quantity, 2)}}
        </template>
        <template v-slot:item.InvoiceAmount="{ item }">
          {{$root.moneyValue(item.InvoiceAmount, 2)}}
        </template>

      </v-data-table>
    </v-card>

    <v-dialog v-model="expensesModal" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <h2>{{$t('Loads.ExpensesTitle')}}</h2><v-spacer></v-spacer><v-btn icon @click="expensesModal=false;"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <LoadExpenses :key="expensesModalKey"
                      :expensesArray="selectedExpenses"
                      :readOnly="!$root.isLoadsEditAllowed"
                      :isFinished="selectedFinishedField !== 0"
                      :loadId="selectedExpensesLoadId"
                      @expensesSaved="fetchData()"
        ></LoadExpenses>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import reportsMixin from '../../mixins/reportsMixin.js';
import LoadExpenses from '../../components/LoadExpenses';
import FiltersPanel from '../../components/FiltersPanel';
import ExpensesReportTemplate from './ExpensesReportTemplate';
import ReportActions from '../../components/ReportActions';
import ExpensesTotals from './ExpensesTotals';

export default {
  name: 'ExpensesReport',
  props: ['from', 'to', 'selectedStr', 'reportData', 'importPilotLoading', 'importFleetOneLoading', 'importTCSLoading', 'companyId'],
  components: { FiltersPanel, LoadExpenses, ReportActions, ExpensesReportTemplate, ExpensesTotals },
  mixins: [reportsMixin],
  data: function () {
    return {
      loading: false,
      items: [],
      search: '',
      selectedItems: [],
      attModal: false,
      attUPLOAD: '',
      totalsCounts: {
        count: 0,
        loadsCount: 0,
        trucksCount: 0,
        expensesByTrucks: 0,
        toCompensate: 0,
        bonuses: 0,
        deductions: 0,
        total: 0
      },
      userFilter: {
        name: 'filterUser',
        label: 'User',
        field: '',
        list: [],
        multiple: true
      },
      truckFilter: {
        name: 'filterTruck',
        label: 'Truck',
        field: '',
        list: [],
        multiple: true
      },
      productFilter: {
        name: 'filterProduct',
        label: 'Product',
        field: '',
        list: [],
        multiple: true
      },
      typeFilter: {
        name: 'filterType',
        label: 'Type',
        field: '',
        list: [
          { id: 0, name: 'Expense' },
          { id: 1, name: 'Compensate' },
          { id: 2, name: 'Bonus' },
          { id: 3, name: 'Deduction' }
        ],
        multiple: true
      },
      methodFilter: {
        name: 'filterMethod',
        label: 'Method',
        field: '',
        list: [
        ],
        multiple: true
      },
      filterUserId: 0,
      filterTruckId: 0,
      filterProduct: 0,
      filterType: 0,
      filterMethod: 0,
      reportsGroupsListKey: new Date().getTime(),
      headers: [
        { text: 'Trx Date', value: 'TrxDate' },
        { text: 'Created', value: 'createdBy' },
        { text: 'Load', value: 'loadId' },
        { text: 'Driver', value: 'user' },
        { text: 'Type', value: 'compensate' },
        { text: 'Method', value: 'paymentMethod' },
        { text: 'Truck', value: 'truckName' },
        { text: 'Transaction #', value: 'Transaction' },
        { text: 'Product', value: 'Product' },
        { text: 'Qty', value: 'Quantity' },
        { text: 'PerItem', value: 'PerItem' },
        { text: 'Amount', value: 'InvoiceAmount' }
        /* { text: '', value: 'actions', sortable: false } */
      ],
      expensesModal: false,
      expensesModalKey: new Date().getTime(),
      selectedExpenses: [],
      selectedExpensesLoadId: 0,
      selectedFinishedField: 0,
      isFilterInitialized: false,
      currentDateTime: ''
    };
  },
  computed: {
  },
  mounted () {
    this.$root.setLastListPath(this.$route.path);
    this.setExpensesTotalsHeaders();
    /*this.$root.getGlobalSettingsField('trucksMaintenanceTypes').then((response) => {
      if (response.status === 'ok') {
        this.typeFilter.list = JSON.parse(response.result);
        this.typeFilter.list.unshift({ id: '', name: 'All' });
      }
    });*/

    this.$root.getGlobalSettingsField('expensePaymentTypes').then((response) => {
      if (response.status === 'ok') {
        this.methodFilter.list = [];
        const _arr = JSON.parse(response.result);
        for (let i = 0; i < _arr.length; i++) {
          this.methodFilter.list.push({
            id: _arr[i],
            name: _arr[i]
          });
        }
      }
    });
    this.$nextTick(() => {
      this.fetchData().then(() => {
        this.isFilterInitialized = true;
      });
    });
  },
  methods: {
    onShowExpenses (expensesJSON, finishedField, loadId) {
      this.selectedExpensesLoadId = loadId;
      this.selectedExpenses = JSON.parse(expensesJSON) || [];
      this.selectedFinishedField = finishedField;
      this.expensesModalKey = new Date().getTime();
      this.expensesModal = true;
    },
    onItemSelected () {
      this.$nextTick(() => {
        let i = 0;
        let selected = [];
        for (i = 0; i < this.selectedItems.length; i++) {
          selected.push(parseInt(this.selectedItems[i]['id']));
        }
        this.$emit('selected', selected);
      });
    },
    onFilterChanged (e) {
      this.filterUser = 0;
      this.filterTruck = 0;
      this.filterProduct = 0;
      this.filterType = 0;
      this.filterMethod = 0;

      if (e.filterUser !== '' && e.filterUser.length > 0) {
        this.filterUser = parseInt(e.filterUser);
      }
      if (e.filterTruck !== '' && e.filterTruck.length > 0) {
        this.filterTruck = parseInt(e.filterTruck);
      }
      if (e.filterProduct !== '' && e.filterProduct.length > 0) {
        this.filterProduct = e.filterProduct;
      }
      if (e.filterType !== '' && e.filterType.length > 0) {
        this.filterType = e.filterType;
      }
      if (e.filterMethod !== '' && e.filterMethod.length > 0) {
        this.filterMethod = e.filterMethod;
      }
      if (this.isFilterInitialized) {
        this.fetchData();
      }
    },
    showAttModal (field) {
      this.attUPLOAD = field;
      this.attModal = true;
    },
    clearTotals () {
      this.$set(this, 'totalsCounts', {
        count: 0,
        loadsCount: 0,
        trucksCount: 0,
        expensesByTrucks: 0,
        toCompensate: 0,
        bonuses: 0,
        deductions: 0,
        total: 0
      });
    },
    fetchData (skipSelected = false, selected = []) {
      return new Promise((resolve, reject) => {
        if (!this.from || !this.to) {
          resolve();
          return;
        }
        let i = 0;
        let loadsIds = {};
        let trucksIds = {};
        this.loading = true;
        this.getReportExpenses(this.from, this.to, this.filterUser, this.filterTruck, this.filterProduct, this.filterType, this.filterMethod).then((response) => {
          if (response.status === 'ok') {
            this.clearTotals();
            this.currentDateTime = response.currentDateTime;

            let selectedArray = [];
            if (!skipSelected && this.selectedStr) {
              selectedArray = this.selectedStr.split(',').map(v => {
                return parseInt(v);
              });
            }
            else if (!skipSelected && selected.length > 0) {
              for (let i = 0; i < selected.length; i++) {
                selectedArray.push(selected[i]);
              }
            }
            this.selectedItems = [];

            this.items = [];
            for (i = 0; i < response.results.length; i++) {
              let _item = response.results[i];
              if (selectedArray.length > 0 && selectedArray.indexOf(parseInt(response.results[i].id)) < 0) continue;
              response.results[i].createdBy = response.results[i].userCreatedFirstName + ' ' + response.results[i].userCreatedLastName;
              response.results[i].user = response.results[i].userFirstName + ' ' + response.results[i].userLastName;

              this.items.push(response.results[i]);

              this.items[this.items.length - 1].startedPST = response.results[i].createdPST;
              this.items[this.items.length - 1].endedPST = response.results[i].createdPST;

              // Calc totals
              this.totalsCounts.count++;

              if (_item.loadId > 0) {
                loadsIds[_item.loadId] = true;
              }

              if (_item.truckId > 0) {
                trucksIds[_item.truckId] = true;
                this.totalsCounts.expensesByTrucks += parseFloat(_item.InvoiceAmount);
              }

              if (_item.compensateCode === 1) {
                this.totalsCounts.toCompensate += parseFloat(_item.InvoiceAmount);
                this.totalsCounts.total += parseFloat(_item.InvoiceAmount);
              } else if (_item.compensateCode === 2) {
                this.totalsCounts.bonuses += parseFloat(_item.InvoiceAmount);
                this.totalsCounts.total += parseFloat(_item.InvoiceAmount);
              } else if (_item.compensateCode === 3) {
                this.totalsCounts.deductions += parseFloat(_item.InvoiceAmount);
                this.totalsCounts.total -= parseFloat(_item.InvoiceAmount);
              } else {
                this.totalsCounts.total += parseFloat(_item.InvoiceAmount);
              }
            }

            // Totals
            this.totalsCounts.loadsCount = Object.keys(loadsIds).length;
            this.totalsCounts.trucksCount = Object.keys(trucksIds).length;

            this.userFilter.list = response.users;
            this.productFilter.list = response.products;
            this.truckFilter.list = response.trucks;
          }

          this.reportsGroupsListKey = 'reportsGroupsListKey' + new Date().getTime();
          this.$forceUpdate();
          this.onItemSelected();
          resolve({
            count: this.totalsCounts.count,
            loadsCount: this.totalsCounts.loadsCount,
            trucksCount: this.totalsCounts.trucksCount,
            expensesByTrucks: this.totalsCounts.expensesByTrucks,
            toCompensate: this.totalsCounts.toCompensate,
            bonuses: this.totalsCounts.bonuses,
            deductions: this.totalsCounts.deductions,
            total: this.totalsCounts.total,
            expenses: this.items
          });
        });
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>
